/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { FormQualitySection } from '../models/form-quality-section';
import { listAllForForm } from '../fn/form-quality-section/list-all-for-form';
import { ListAllForForm$Params } from '../fn/form-quality-section/list-all-for-form';
import { updateFormQualitySection } from '../fn/form-quality-section/update-form-quality-section';
import { UpdateFormQualitySection$Params } from '../fn/form-quality-section/update-form-quality-section';

@Injectable({ providedIn: 'root' })
export class FormQualitySectionService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `formQualitySectionControllerListAllForForm()` */
  static readonly FormQualitySectionControllerListAllForFormPath = '/forms/{formId}/quality-section';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listAllForForm()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAllForForm$Response(
    params: ListAllForForm$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<FormQualitySection>>> {
    return listAllForForm(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listAllForForm$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAllForForm(params: ListAllForForm$Params, context?: HttpContext): Observable<Array<FormQualitySection>> {
    return this.listAllForForm$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<FormQualitySection>>): Array<FormQualitySection> => r.body)
    );
  }

  /** Path part for operation `formQualitySectionControllerUpdateFormQualitySection()` */
  static readonly FormQualitySectionControllerUpdateFormQualitySectionPath = '/forms/{formId}/quality-section';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateFormQualitySection()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFormQualitySection$Response(
    params: UpdateFormQualitySection$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<FormQualitySection>> {
    return updateFormQualitySection(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateFormQualitySection$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFormQualitySection(
    params: UpdateFormQualitySection$Params,
    context?: HttpContext
  ): Observable<FormQualitySection> {
    return this.updateFormQualitySection$Response(params, context).pipe(
      map((r: StrictHttpResponse<FormQualitySection>): FormQualitySection => r.body)
    );
  }
}
